import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Layout from "components/Layout";
import api from "utils/api";
import "styles/auth.css";

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password.length < 8) {
      setFeedback({ kind: "error", message: "Das Passwort muss mindestens 8 Zeichen lang sein." });
      return;
    }
    if (password !== passwordConfirm) {
      setFeedback({ kind: "error", message: "Die Passwörter stimmen nicht überein." });
      return;
    }
    setSubmitting(true);
    setFeedback(null);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setFeedback({ kind: "success", message: data?.message || "Passwort zurückgesetzt." });
      setTimeout(() => navigate("/einloggen", { replace: true }), 1200);
    } catch (err) {
      setFeedback({
        kind: "error",
        message: err?.response?.data?.message || "Zurücksetzen fehlgeschlagen.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <Layout>
        <section className="auth-page">
          <div className="auth-card">
            <div className="auth-kicker">Passwort zurücksetzen</div>
            <h1>Token <em>fehlt</em></h1>
            <p className="auth-lead">
              Der Link ist unvollständig. Bitte fordere einen neuen Link über{" "}
              <Link to="/auth/passwort-vergessen">Passwort vergessen</Link> an.
            </p>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="auth-page">
        <div className="auth-card">
          <div className="auth-kicker">Passwort zurücksetzen</div>
          <h1>
            Neues <em>Passwort</em>
          </h1>
          <p className="auth-lead">Wähle ein neues, sicheres Passwort.</p>

          {feedback && (
            <div className={`auth-alert is-${feedback.kind}`}>{feedback.message}</div>
          )}

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div>
              <label htmlFor="reset-pw">Neues Passwort</label>
              <input
                id="reset-pw"
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="reset-pw2">Passwort wiederholen</label>
              <input
                id="reset-pw2"
                type="password"
                required
                minLength={8}
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
              />
            </div>
            <div className="auth-actions">
              <button type="submit" className="auth-submit" disabled={submitting}>
                {submitting ? "Speichern..." : "Neues Passwort speichern"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </Layout>
  );
};

export default ResetPasswordPage;
